export default __webpack_public_path__ + "static/javascript-738cb538640f290677c4053eecc09bf8.png";